<script lang="ts">
  import clsx from 'clsx';
  import type { BlockquoteProps } from './types';

  const { children, class: className }: BlockquoteProps = $props();
</script>

<blockquote class={clsx(className, 'border-l-4 border-st-yellow pl-3 italic')}>
  {#if typeof children === 'string'}
    {children}
  {:else}
    {@render children()}
  {/if}
</blockquote>
